const STORAGE_THEME = 'ipscape-theme';

export type Theme = 'light' | 'dark';

export function getStoredTheme(): Theme {
  if (typeof window === 'undefined') return 'dark';
  const s = localStorage.getItem(STORAGE_THEME);
  return s === 'light' || s === 'dark' ? s : 'dark';
}

export function setStoredTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_THEME, theme);
  document.documentElement.setAttribute('data-theme', theme);
}
